import React, { useState, useEffect, lazy, Suspense } from "react";
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'
import { useTranslation } from "react-i18next";
import Container from '@material-ui/core/Container';
import Skeleton from '@material-ui/lab/Skeleton';
import LoadingImage from './assets/img/loading.gif';
const Header = lazy(() => import('./components/Header/Header'));
const Video = lazy(() => import('./components/Video/Video'));
const Properties = lazy(() => import('./components/Properties/Properties'));
const Products = lazy(() => import('./components/Products/Products'));
const Faq = lazy(() => import('./components/Faq/Faq'));
const Gallery = lazy(() => import('./components/Gallery/Gallery'));
const Blog = lazy(() => import('./components/Blog/Blog'));
const AboutUs = lazy(() => import('./components/AboutUs/AboutUs'));
const Awards = lazy(() => import('./components/Awards/Awards'));
const Footer = lazy(() => import('./components/Footer/Footer'));


function App() {

  const [state, setState] = useState({
    mobileView: false,
    drawerOpen: false,
  });
  const gtmParams = { id: 'GTM-WDTDP67' }

  const { t } = useTranslation();

  const Loading = () => (
    <div className="loading"><img src={LoadingImage} alt="Indigo Nails Cooperation Loading..." /></div>
  )

  useEffect(() => {

    document.title = t('title');
    document.querySelector('meta[name="description"]').setAttribute("content", t('description'));

    const setResponsiveness = () => {
      return window.innerWidth < 900
        ? setState((prevState) => ({ ...prevState, mobileView: true }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();

    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, [t]);

  return (
    <GTMProvider state={gtmParams}>
      <Suspense fallback={<Loading />}>
        <Container className="mainContainer">
            <Header state={state} setState={setState} />
            <Video/>
            <Properties />
            <Products state={state} />
            <Faq />
            {<Gallery /> ? (<Gallery />) : (<Skeleton variant="react" width={1180} height={590} animation="wave" ></Skeleton>)}
            {/* <Blog state={state} /> */}
            {/* <AboutUs /> */}
            <Awards />
            {/* <Bestsellers /> */}
            <Footer />
        </Container>
      </Suspense>
    </GTMProvider>
  );
}

export default App;